import React, {useState}from "react";
import '../css/portfolio.css';


import PortfolioBlock from "../layout/portfolio_block";

import {dataList} from './placeholder/porfolioData'

import artistData from './placeholder/artistData'


function Portfolio() {

 
    const [selectedArtist, setSelectedArtist] = useState(0);
    const [selectedCatogory, setSelectedCatogory] = useState(0);

    

    const catogoryOptions = ['Traditional/Old School',
                            'Neo-Traditional',
                            'Realism',
                            'Portrait',
                            'Japanese',
                            'Chinese',
                            'Tribal',
                            'Blackwork',
                            'Dotwork',
                            'Watercolor',
                            'Geometric']



    const filterPortfolio = () => {

        const searchArtist = (data:Portfolio) => {

            if (selectedArtist === 0) {
                return data;
            } else {

                return selectedArtist-1 === data.artistId
            }

        }

      

        return dataList.filter(
            (data) => 

            searchArtist(data) && (selectedCatogory !== 0 ? catogoryOptions[selectedCatogory-1] === data.category : data)

        )
        
    }

    return (

        <section id="Portfolio">

            <div className="container portfolio__container">

                <h1>Our Work</h1>

                <h2>Here is ours works</h2>

                <div className="portfolio__filter">
                    
                    <select onChange={e => setSelectedArtist(parseInt(e.target.value, 10))}>
                        <option value='0'>All Artist</option>
                        {artistData.map((data) => <option value={data.id+1}>{data.name}</option>)}
                    </select>

                    <select onChange={e => setSelectedCatogory(parseInt(e.target.value, 10))}>
                    <option value="0" >All Category</option>
                    {catogoryOptions.map ((data, index) => <option value={index+1}>{data}</option>)};

                    </select>
                    
               

                </div>
                
                <div className="portfolio__content">

                    {filterPortfolio().map( (data) => (

                    <PortfolioBlock data={data}/>

                    ))}



                </div>


            </div>



        </section>
    );

}

export default Portfolio;